export default (t: (id: string, obj?: Object) => string) => ({
  aiTeamEnabled: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: t("AI_TEAM"),
      description: t("AI_TEAM_DESCRIPTION"),
    },
  },
  chatbotBomanEnabled: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: "Boman",
      description: t("BOMAN_DESCRIPTION"),
    },
  },
  chatbotClaudiaEnabled: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: "Claudia",
      description: t("CLAUDIA_DESCRIPTION"),
    },
  },
  chatbotMorganEnabled: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: "Morgan",
      description: t("MORGAN_DESCRIPTION"),
    },
  },
  chatbotShaniEnabled: {
    "ui:widget": "switch-button",
    "ui:options": {
      label: "Shani",
      description: t("SHANI_DESCRIPTION"),
    },
  },
  "ui:order": [
    "aiTeamEnabled",
    "chatbotBomanEnabled",
    "chatbotClaudiaEnabled",
    "chatbotMorganEnabled",
    "chatbotShaniEnabled",
  ],
});
